import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5cfb8f43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fixed top-0 right-0 left-0 overflow-hidden z-50 flex-container bg-gradient-to-t from-black full-mode" }
const _hoisted_2 = { class: "video-background" }
const _hoisted_3 = { class: "lyrics-section flex-item" }
const _hoisted_4 = {
  key: 0,
  class: "controls"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/icons/tabler-icon-player-play.svg" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "lyrics-background" }
const _hoisted_8 = { class: "lyrics h-full sm:h-14" }
const _hoisted_9 = ["id"]
const _hoisted_10 = ["id", "delay"]
const _hoisted_11 = ["id", "delay"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_13 = ["id", "delay"]
const _hoisted_14 = ["id", "delay"]
const _hoisted_15 = ["id", "delay"]
const _hoisted_16 = { class: "mode-controls top-0" }
const _hoisted_17 = ["title"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    stroke: "currentColor",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "1.5",
    d: "M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243"
  })
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "line-controls sm:flex sm:w-full sm:gap-4" }
const _hoisted_21 = { class: "grid grid-flow-row auto-rows-max text-center" }
const _hoisted_22 = ["disabled", "title"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M4 4a.5.5 0 0 1 1 0v3.248l6.267-3.636c.54-.313 1.232.066 1.232.696v7.384c0 .63-.692 1.01-1.232.697L5 8.753V12a.5.5 0 0 1-1 0V4z"
  })
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { class: "text-gray-300" }
const _hoisted_26 = { class: "grid grid-flow-row auto-rows-max text-center" }
const _hoisted_27 = ["title"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"
  })
], -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { class: "text-gray-300" }
const _hoisted_31 = { class: "grid grid-flow-row auto-rows-max text-center" }
const _hoisted_32 = ["disabled", "title"]
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  preserveAspectRatio: "xMidYMid meet",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M12.5 4a.5.5 0 0 0-1 0v3.248L5.233 3.612C4.693 3.3 4 3.678 4 4.308v7.384c0 .63.692 1.01 1.233.697L11.5 8.753V12a.5.5 0 0 0 1 0V4z"
  })
], -1))
const _hoisted_34 = [
  _hoisted_33
]
const _hoisted_35 = { class: "text-gray-300" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_YouTube = _resolveComponent("YouTube")!
  const _component_fg = _resolveComponent("fg")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("aside", _hoisted_2, [
        _createVNode(_component_YouTube, {
          id: "player",
          class: "video-foreground",
          style: {"position":"absolute","z-index":"10","width":"auto","min-width":"100%","min-height":"100%","max-width":"none"},
          width: "auto",
          height: "100%",
          "min-width": "100%",
          "min-height": "100%",
          "max-width": "none",
          src: 'https://www.youtube.com/watch?v=' + _ctx.lyrics.videoId,
          onReady: _ctx.onReady,
          onStateChange: _ctx.onPlayerStateChange,
          onError: _ctx.onPlayerError,
          vars: _ctx.playerVars,
          host: "localhost:8080",
          ref: "player"
        }, null, 8, ["src", "onReady", "onStateChange", "onError", "vars"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.isPlaying && !_ctx.isWaitingInput)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btn btn-icon btn-medium",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startTimer && _ctx.startTimer(...args))),
                title: "actions.play"
              }, _hoisted_6)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("ul", _hoisted_8, [
            (_ctx.lyrics)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.lyrics.verses, (lyric, i) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: lyric.id,
                    id: 'ly-' + i,
                    class: "lyric text-base sm:text-4xl md:text-5xl noselect"
                  }, [
                    _createElementVNode("ul", null, [
                      (lyric.characters)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(lyric.characters, (character) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: character.i
                            }, [
                              (character.q && character.q == true)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (character.t == 1 || character.t == 3)
                                      ? (_openBlock(), _createElementBlock("li", {
                                          key: 0,
                                          id: 'ch-' + character.i,
                                          class: "character",
                                          delay: character.d
                                        }, [
                                          _createVNode(_component_fg, {
                                            id: 'fg-' + character.i,
                                            t: "?",
                                            class: "glowing"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(character.c), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["id"])
                                        ], 8, _hoisted_10))
                                      : _createCommentVNode("", true),
                                    (character.t == 2 || character.t == 4)
                                      ? (_openBlock(), _createElementBlock("li", {
                                          key: 1,
                                          id: 'ch-' + character.i,
                                          class: "character glowing",
                                          delay: character.d
                                        }, [
                                          _createVNode(_component_fg, {
                                            id: 'fg-' + character.i,
                                            t: character.f
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_12
                                            ]),
                                            _: 2
                                          }, 1032, ["id", "t"])
                                        ], 8, _hoisted_11))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (character.c == '')
                                      ? (_openBlock(), _createElementBlock("li", {
                                          key: 0,
                                          id: 'ch-' + character.i,
                                          class: "character",
                                          delay: character.d
                                        }, " ", 8, _hoisted_13))
                                      : (character.f && character.f !== '')
                                        ? (_openBlock(), _createElementBlock("li", {
                                            key: 1,
                                            id: 'ch-' + character.i,
                                            class: "character",
                                            delay: character.d
                                          }, [
                                            _createVNode(_component_fg, {
                                              id: 'fg-' + character.i,
                                              t: character.f
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(character.c), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["id", "t"])
                                          ], 8, _hoisted_14))
                                        : (_openBlock(), _createElementBlock("li", {
                                            key: 2,
                                            id: 'ch-' + character.i,
                                            class: "character",
                                            delay: character.d
                                          }, _toDisplayString(character.c), 9, _hoisted_15))
                                  ], 64))
                            ], 64))
                          }), 128))
                        : _createCommentVNode("", true)
                    ])
                  ], 8, _hoisted_9))
                }), 128))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("button", {
        class: "btn btn-icon btn-secondary btn-close btn-medium",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
        title: _ctx.actions_goback
      }, _hoisted_19, 8, _hoisted_17)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-secondary btn-medium btn-previous flex flex-col justify-center content-center align-middle",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToPreviousLine && _ctx.goToPreviousLine(...args))),
          disabled: (!_ctx.isPlaying && !_ctx.isWaitingInput) || _ctx.currentline == 0,
          title: _ctx.actions_go_prev_verse
        }, _hoisted_24, 8, _hoisted_22),
        _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.actions_repeat_verse), 1)
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-secondary btn-medium btn-next flex flex-col justify-center content-center align-middle w-20 h-20 rounded-full",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.togglePlay && _ctx.togglePlay(...args))),
          title: _ctx.actions_repeat_verse
        }, _hoisted_29, 8, _hoisted_27),
        _createElementVNode("small", _hoisted_30, _toDisplayString(_ctx.actions_pause), 1)
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("button", {
          class: "btn btn-icon btn-secondary btn-medium btn-next flex flex-col justify-center content-center align-middle",
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goToNextLine && _ctx.goToNextLine(...args))),
          disabled: (!_ctx.isPlaying && !_ctx.isWaitingInput),
          title: _ctx.actions_go_next_verse
        }, _hoisted_34, 8, _hoisted_32),
        _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.actions_skip), 1)
      ])
    ])
  ], 64))
}